import { memo } from "react";
import { Button, Div, PageHeader, useTheme } from "react-better-html";

import { useI18n } from "../../../utils/i18n";
import { useReduxState } from "../../../utils/hooks";

import Section from "../../../components/structure/Section";

function DataPrivacySection() {
   const theme = useTheme();
   const { t } = useI18n();

   const firebaseUser = useReduxState((state) => state.user.firebaseUser);

   return firebaseUser ? (
      <Section title={t((l) => l.pages.account.sections.dataPrivacy.title)}>
         <Div.column gap={theme.styles.gap}>
            <Div.box backgroundColor={theme.colors.backgroundBase}>
               <Div.row alignItems="center" gap={theme.styles.space}>
                  <Div flex={1}>
                     <PageHeader title={t((l) => l.templates.privacyPolicy)} titleAs="h4" marginBottom={0} />
                  </Div>

                  <Button.text
                     text={t((l) => l.common.open)}
                     href="/legal/privacy-policy"
                     target="_blank"
                     icon="externalLink"
                     iconPosition="right"
                     color={theme.colors.primary}
                  />
               </Div.row>
            </Div.box>

            <Div.box backgroundColor={theme.colors.backgroundBase}>
               <Div.row alignItems="center" gap={theme.styles.space}>
                  <Div flex={1}>
                     <PageHeader title={t((l) => l.templates.termsAndConditions)} titleAs="h4" marginBottom={0} />
                  </Div>

                  <Button.text
                     text={t((l) => l.common.open)}
                     href="/legal/terms-and-conditions"
                     target="_blank"
                     icon="externalLink"
                     iconPosition="right"
                     color={theme.colors.primary}
                  />
               </Div.row>
            </Div.box>

            <Div.box backgroundColor={theme.colors.backgroundBase}>
               <Div.row alignItems="center" gap={theme.styles.space}>
                  <Div flex={1}>
                     <PageHeader
                        title={t((l) => l.pages.account.sections.dataPrivacy.items.requestMyData)}
                        description={t((l) => l.pages.account.sections.dataPrivacy.items.requestMyDataDescription)}
                        descriptionFontSize={14}
                        titleAs="h4"
                        marginBottom={0}
                     />
                  </Div>

                  <Button.text
                     text={t((l) => l.pages.account.sections.dataPrivacy.contactSupport)}
                     href="/support"
                     color={theme.colors.primary}
                  />
               </Div.row>
            </Div.box>
         </Div.column>
      </Section>
   ) : undefined;
}

export default memo(DataPrivacySection);
